import React from 'react'
import PropTypes from 'prop-types';
import {
    ActionButtonContainer,
    CustomAddShiftButton,
} from './ShiftDetailsPanel.styles';
import AutoStaff from '../../../AutoStaff/AutoStaff';
import { DRAWER_TYPES } from '../../../../pages/Dashboard/dashboardDrawerConfig';


const DailyShiftsActionButtons = ({ selectedDay, shifts, handleOpenDrawer }) => {

    const handleBottomAddShift = () => {
        // Open AddShiftForm and skip only the date selection step
        handleOpenDrawer(DRAWER_TYPES.ADD_SHIFT, {
            selectedDate: new Date(selectedDay),
            dateFromShiftButton: selectedDay,
        });
    };

    return (
        <ActionButtonContainer>
            <AutoStaff
                variant="light"
                fullWidth={true}
                selectedDay={selectedDay}
                periodHasShifts={shifts.length > 0}
            />
            <CustomAddShiftButton onClick={handleBottomAddShift}>
                Add shift
            </CustomAddShiftButton>
        </ActionButtonContainer>
    );
};

DailyShiftsActionButtons.propTypes = {
    selectedDay: PropTypes.string.isRequired,
    shifts: PropTypes.array.isRequired,
    handleOpenDrawer: PropTypes.func.isRequired,
};

export default DailyShiftsActionButtons;